export const fetchWebtools = resp => {
  return {
    type: "FETCH_WEBTOOLS",
    payload: resp
  };
};
export const resetWebtools = () => {
  return {
    type: "RESET_WEBTOOLS"
  };
};

// Webtool favorites actions
export const fetchWebtoolsFavorites = resp => {
  return {
    type: "FETCH_WEBTOOLS_FAVORITES",
    payload: resp
  };
};
export const resetWebtoolsFavorites = () => {
  return {
    type: "RESET_WEBTOOLS_FAVORITES"
  };
};
export const reduceWebtools = favorites => ({
  type: "REDUCE_WEBTOOLS",
  favorites
});
export const clickPlus = () => ({
  type: "CLICK_PLUS"
});
export const clickMinus = () => ({
  type: "CLICK_MINUS"
});
export const addToWebtools = favorite => ({
  type: "ADD_TO_WEBTOOLS",
  favorite
});
export const addToFavoritesReducer = favorite => ({
  type: "ADD_TO_FAVORITES_REDUCER",
  favorite
});
export const removeFromFavoritesReducer = favorite => ({
  type: "REMOVE_FROM_FAVORITES_REDUCER",
  favorite
});

//categories
export const fetchWebtoolsCategories = resp => {
  return {
    type: "FETCH_WEBTOOLS_CATEGORIES",
    payload: resp
  };
};
export const setFilterCategory = categoryId => ({
  type: "SET_FILTER_CATEGORY",
  categoryId
});

export const setFilterSearch = (search, lng) => ({
  type: "SET_FILTER_SEARCH",
  search,
  lng
});

export const filterWebtools = filter => ({
  type: "FILTER_WEBTOOLS",
  filter
});



// WEBPACK FOOTER //
// ./src/actions/actions/webtool.js